export default "__VITE_PUBLIC_ASSET__617a16a1__"